import { rankingData } from '@/mocks/homepage';

export default function RankingSection() {
  const trendIcons: Record<string, string> = {
    up: 'ri-arrow-up-line text-accent-500',
    down: 'ri-arrow-down-line text-secondary-600',
    steady: 'ri-subtract-line text-foreground-500',
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-bar-chart-line text-sm"></i>
            </div>
            热播榜单
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            TOP5 热播影视排行榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            基于91视频网站和久久视频全网播放数据实时更新
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-accent-50/50 transition-colors cursor-pointer`}
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-bold text-lg font-heading ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-300 text-background-50'
                    : item.rank === 3
                    ? 'bg-accent-200 text-accent-800'
                    : 'bg-background-100 text-foreground-700'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-base font-bold text-foreground-900 font-heading whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">
                  {item.heat}
                </span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${trendIcons[item.trend]} text-sm`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}